// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VdwM","tabsBox":"styles_tabsBox__302IY","createButton":"styles_createButton__3SmSb"};